<script>
export default {
  template: '<template></template>',
}
</script>

<style lang="scss">
@use '../../AboutUs/AboutUs';
@use '../../AboutUs/AboutSection';
@use '../../ContactBlock/ContactBlock';
</style>
